<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="师傅id,外键{}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入师傅id,外键{}" />
      </a-form-model-item>
      <a-form-model-item label="师傅订单id,外键{zb_master_order.id}" prop="masterOrderId" >
        <a-input v-model="form.masterOrderId" placeholder="请输入师傅订单id,外键{zb_master_order.id}" />
      </a-form-model-item>
      <a-form-model-item label="打卡时间" prop="checkTime" >
        <a-date-picker style="width: 100%" v-model="form.checkTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="打卡类型,1-上班,2-迟到,3-早退,4-下班" prop="checkType" >
      </a-form-model-item>
      <a-form-model-item label="打卡图片" prop="checkImg" >
        <a-input v-model="form.checkImg" placeholder="请输入打卡图片" />
      </a-form-model-item>
      <a-form-model-item label="当天打卡次数" prop="checkNum" >
        <a-input v-model="form.checkNum" placeholder="请输入当天打卡次数" />
      </a-form-model-item>
      <a-form-model-item label="早退申请状态,0-未申请,1-待审批,2-已通过,3-已拒绝" prop="leaveEarlyStatus" >
      </a-form-model-item>
      <a-form-model-item label="早退申请原因" prop="leaveEarlyReason" >
        <a-input v-model="form.leaveEarlyReason" placeholder="请输入早退申请原因" />
      </a-form-model-item>
      <a-form-model-item label="早退申请图片,多个使用逗号分开" prop="leaveEarlyImg" >
        <a-input v-model="form.leaveEarlyImg" placeholder="请输入早退申请图片,多个使用逗号分开" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addRecord, getRecord, updateRecord} from '@/api/check/record'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        masterOrderId: null,

        checkTime: null,

        checkType: null,

        checkImg: null,

        checkNum: null,

        leaveEarlyStatus: 0,

        leaveEarlyReason: null,

        leaveEarlyImg: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '师傅id,外键{}不能为空', trigger: 'blur' }
        ],
        masterOrderId: [
          { required: true, message: '师傅订单id,外键{zb_master_order.id}不能为空', trigger: 'blur' }
        ],
        checkTime: [
          { required: true, message: '打卡时间不能为空', trigger: 'blur' }
        ],
        checkType: [
          { required: true, message: '打卡类型,1-上班,2-迟到,3-早退,4-下班不能为空', trigger: 'change' }
        ],
        checkImg: [
          { required: true, message: '打卡图片不能为空', trigger: 'blur' }
        ],
        checkNum: [
          { required: true, message: '当天打卡次数不能为空', trigger: 'blur' }
        ],
        leaveEarlyStatus: [
          { required: true, message: '早退申请状态,0-未申请,1-待审批,2-已通过,3-已拒绝不能为空', trigger: 'blur' }
        ],
        leaveEarlyReason: [
          { required: true, message: '早退申请原因不能为空', trigger: 'blur' }
        ],
        leaveEarlyImg: [
          { required: true, message: '早退申请图片,多个使用逗号分开不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        masterOrderId: null,
        checkTime: null,
        checkType: null,
        checkImg: null,
        checkNum: null,
        leaveEarlyStatus: 0,
        leaveEarlyReason: null,
        leaveEarlyImg: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
